import React from 'react';
import LottieAnimation from '@/v1/components/behaviours/LottieAnimation';
import Icon from '@/v1/components/atoms/Icon';
import animationData from './LottiePhoneRotate.json';

const PhoneRotate = (props) => (
    <Icon iconName="PhoneRotate" {...props}>
        <LottieAnimation loop autoplay animationData={animationData} />
    </Icon>
);

export default PhoneRotate;
